import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index/index'),
    redirect: '/:gameName/:page/:alias/:gameIdKey',
    children: [
      {
      // 主页, account/app
        path: ':gameName/:page/:alias/:gameIdKey',
        component: () => import('@/views/index/list')
      },
      {
        // 单个section的faqList
        // path: 'List/:gameName',
        path: ':gameName/:page/:alias/:gameIdKey/:sectionIdKey',
        component: () => import('@/views/index/faqList')
      },
      {
        // detail
        // path: 'List/Detail/:gameName',
        path: ':gameName/:page/:alias/:gameIdKey/:sectionIdKey/:kmContentIdKey',
        component: () => import('@/views/index/detail')
      },
    ]
  },
  {
    path: '*',
    component: () => import('@/views/page_404')
  }
]

const router = new VueRouter({
  routes
})

export default router